import axios from 'axios'

export default {
    async getMyApprovals() {
        try{            
            const response = await axios.get(`ApprovalInbox/my-approvals`)            
            return response
        }catch (error){
            console.log('ApprovalInbox api get error')
            throw error
        }
    },
    async getMyRequests() {
        try{            
            const response = await axios.get(`ApprovalInbox/my-requests`)            
            return response
        }catch (error){
            console.log('ApprovalInbox api get error')
            throw error
        }
    },
}